var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Theme from 'Theme';
import UserRecovery from 'modules/Users/containers/UserRecovery';
import { Logo } from 'components';
var Recovery = /** @class */ (function (_super) {
    __extends(Recovery, _super);
    function Recovery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Recovery.prototype.render = function () {
        return (React.createElement(Wrapper, null,
            React.createElement(StyledLogo, { width: 250 }),
            React.createElement(UserRecovery, null)));
    };
    return Recovery;
}(Component));
export default Recovery;
var Wrapper = cxs('div')({
    boxShadow: "0 0 100px -20px ".concat(opacity(0.25, Theme.color.primary)),
    margin: 'auto',
    borderWidth: "".concat(Theme.size.hairline),
    borderColor: Theme.color.hairline,
    borderStyle: 'solid'
});
var StyledLogo = cxs(Logo)({
    margin: "".concat(Theme.size.space[4], " ").concat(Theme.size.space[4], " 0 ").concat(Theme.size
        .space[4])
});



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Recovery.tsx
// module id = 1630
// module chunks = 0